module.exports = __webpack_public_path__ + "static/media/menu.83a3adb3.svg";